import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminLayout } from './layouts/AdminLayout';
import { DashboardPage } from './pages/DashboardPage';
import { SessionsPage } from './pages/SessionsPage';
import { SessionDetailPage } from './pages/SessionDetailPage';
import { DataImportPage } from './pages/DataImportPage';
import { SymbolsPage } from './pages/SymbolsPage';
import { DataOverviewPage } from './pages/DataOverviewPage';
import { StrategyBuilderPage } from './pages/StrategyBuilderPage';
import { SchoolPage } from './pages/SchoolPage';
import { ExamPage } from './pages/ExamPage';
import { SavedStrategiesPage } from './pages/SavedStrategiesPage';
import { AiManagerPage } from './pages/AiManagerPage';

export function App() {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/manager" element={<AiManagerPage />} />
        <Route path="/strategy" element={<StrategyBuilderPage />} />
        <Route path="/research/school" element={<SchoolPage />} />
        <Route path="/research/exam" element={<ExamPage />} />
        <Route path="/research/strategies" element={<SavedStrategiesPage />} />
        <Route path="/sessions" element={<SessionsPage />} />
        <Route path="/sessions/:id" element={<SessionDetailPage />} />
        <Route path="/data/import" element={<DataImportPage />} />
        <Route path="/data/symbols" element={<SymbolsPage />} />
        <Route path="/data/overview" element={<DataOverviewPage />} />
      </Route>
    </Routes>
  );
}
